/**
 * Shared status line while marketplace Apply opens the provider board in a new tab.
 * Board-agnostic — pass the short board name via the hook’s `redirectStatus`.
 * When the popup is blocked, show a visible Open {board} link and same-tab action.
 */
export function MarketplaceApplyRedirectStatus({
  message,
  boardName,
  blockedOpenUrl,
  onOpenInSameTab,
}: {
  message: string | null
  boardName?: string
  blockedOpenUrl?: string | null
  onOpenInSameTab?: () => void
}) {
  if (!message && !blockedOpenUrl) return null

  const board = (boardName || 'board').trim() || 'board'

  return (
    <div className="space-y-2" role="status">
      {message ? <p className="text-xs text-muted-foreground">{message}</p> : null}
      {blockedOpenUrl ? (
        <div className="flex flex-wrap items-center gap-3 text-sm">
          <a
            href={blockedOpenUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary underline-offset-4 hover:underline"
          >
            Open {board}
          </a>
          {onOpenInSameTab ? (
            <button
              type="button"
              className="text-muted-foreground underline-offset-4 hover:underline"
              onClick={onOpenInSameTab}
            >
              Open in this tab
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
